/**
 * Created by 1 on 2017/9/12.
 * plotComponent类的外部定义，避免文件过长
 */
'use strict';
define([
    '../utils/CommonUtil',
    '../utils/LayerUtil',
    '../utils/LoggerUtil',
    '../utils/RenderUtil',
    './PlotTypes',
    '../misc/AppEvents',
    // '../components/tailed/TailedLabelComponent',
    '../g2'
], function (CommonUtil,
    LayerUtil,
    LoggerUtil,
    RenderUtil,
    PlotTypes,
    AppEvents,
    // TailedLabelComponent,
    g2) {
    var fn = function (component) {
        //标绘类型定义
        var PATTERNS = PlotTypes.PATTERNS;
        //所有标绘枚举
        var TYPES = PlotTypes.TYPES;
        //
        var TYPE_KEYS = PlotTypes.TYPES_KEYS;
        /**
         * 传递坐标标绘的接口及相关
         */
        component.include({
            /**
             * 绘制点
             * @method
             * @memberOf G.plot.PlotComponent.prototype
             * @param opts {Object} - 必填
             * @param opts.id {String} - 可选，元素id
             * @param opts.layerId {String} - 可选，图层id
             * @param opts.geometry {g2.sfs.Point} - 必填，坐标
             * @param opts.symbol {Object} - 可选，符号
             */
            drawMarker: function (opts) {
                if (opts && opts.geometry instanceof g2.sfs.Point) {
                    var plotElement = this._constructPlotElement(PATTERNS.POINT, opts);
                    var layer = LayerUtil.getLayerById(this.map, opts.layerId);
                    layer = layer || this._plotLayer;
                    layer.add(plotElement);
                    //事件通知
                    this._fireEvent(AppEvents.PLOT_CREATED, {
                        type: TYPE_KEYS.Point,//标绘类型
                        element: plotElement//标绘元素
                    });
                    //
                    this._resetToolState();
                } else {
                    throw (new Error('参数错误！'));
                }
            },
            /**
             * 绘制线
             * @method
             * @memberOf G.plot.PlotComponent.prototype
             * @param opts {Object} - 必填
             * @param opts.id {String} 可选，元素id
             * @param opts.layerId {String} 可选，图层id
             * @param opts.geometry {g2.sfs.Polyline} 必填，坐标
             * @param opts.symbol {Object} 可选，符号
             * @example
             * var wkt='MULTILINESTRING((120.19821 30.3048,120.17499 30.33569,120.12021 30.39978,120.11004 30.41891))';
             * var lineGeom=g2.sfs.GeometryFactory.createGeometryFromWkt(wkt);
             * var options={};
             * options.geometry=lineGeom;
             * options.symbol= {
             *       "type": "SimpleFillSymbol",
             *       "options": {
             *           "borderColor": {
             *               "alpha": 153,
             *               "r": 0,
             *               "g": 0,
             *               "b": 255
             *           },
             *           "fillColor": {
             *               "alpha": 150,
             *               "r": 19,
             *               "g": 181,
             *               "b": 177
             *           },
             *           "borderThickness": 2,
             *           "opacity": 1
             *           }
             *       }
             *  plotComponent.drawLine(options);
             *
             *
             *
             */
            drawLine: function (opts) {
                if (opts) {
                    var plotElement = this._constructPlotElement(PATTERNS.POLYLINE, opts);
                    var layer = LayerUtil.getLayerById(this.map, opts.layerId);
                    layer = layer || this._plotLayer;
                    layer.add(plotElement);
                    //事件通知
                    this._fireEvent(AppEvents.PLOT_CREATED, {
                        type: TYPE_KEYS.Polyline,//标绘类型
                        element: plotElement//标绘元素
                    });
                    //
                    this._resetToolState();
                } else {
                    throw (new Error('参数错误！'));
                }
            },
            /**
             * 绘制面
             * @method
             * @memberOf G.plot.PlotComponent.prototype
             * @param opts {Object} - 必填
             * @param opts.id {String} - 可选，元素id
             * @param opts.layerId {String} - 可选，图层id
             * @param opts.geometry {g2.sfs.Polygon} - 必填，坐标
             * @param opts.symbol {Object} - 可选，符号
             */
            drawPolygon: function (opts) {
                //2018年11月2日17:59:59  支持多面的标绘
                if (opts &&
                    (opts.geometry instanceof g2.sfs.Polygon
                        || opts.geometry instanceof g2.sfs.MultiPolygon)) {
                    var plotElement = this._constructPlotElement(PATTERNS.POLYGON, opts);
                    var layer = LayerUtil.getLayerById(this.map, opts.layerId);
                    layer = layer || this._plotLayer;
                    layer.add(plotElement);
                    //事件通知
                    this._fireEvent(AppEvents.PLOT_CREATED, {
                        type: TYPE_KEYS.Polygon,//标绘类型
                        element: plotElement//标绘元素
                    });
                    //
                    this._resetToolState();
                } else {
                    throw (new Error('参数错误！'));
                }
            },
            /***
             *
             * @param type
             * @param opts
             * @private
             */
            _constructPlotElement: function (type, opts) {
                var symbol = this._getDefaultSymbol(type, opts.symbol);
                var eleName = '';
                //
                var algoMap = {};
                algoMap[PATTERNS.POINT] = TYPE_KEYS.Point;
                algoMap[PATTERNS.POLYLINE] = TYPE_KEYS.Polyline;
                algoMap[PATTERNS.POLYGON] = TYPE_KEYS.Polygon;
                var algorithm = this._getAlgorithm(algoMap[type]);
                var attributes = new g2.sfs.AttributeSet();
                var eleUUID = CommonUtil.newUUID();
                if (opts.hasOwnProperty('name')) {
                    eleName = opts.name + '_' + eleUUID.split('-')[0];
                }
                var plotEle = new g2.sfs.PlotElement({
                    id: opts.id || eleUUID,
                    kind: type,
                    name: eleName,
                    algorithm: algorithm,
                    attributeSet: attributes
                });
                var ele = new g2.sfs.Element({
                    id: opts.id || eleUUID,
                    kind: type,
                    geometry: opts.geometry,
                    symbol: symbol,
                    name: eleName,
                    attributeSet: attributes
                });
                plotEle.add(ele);
                //
                try {
                    this._handleControlPoint(plotEle);
                } catch (e) {
                    LoggerUtil.error(e);
                }
                //
                plotEle.reset();
                return plotEle;
            },
            /**
             * 处理标绘的控制的，支持鼠标编辑（只支持简单几何：单点、单线、单面）
             * @param plotElement
             * @private
             */
            _handleControlPoint: function (plotElement) {
                var geom = plotElement.elements[0].geometry,
                    plot = plotElement.plot;
                var obj = {
                    point: {
                        regex: /^(.*Point),http\:\/\/www.Gs.com$/,
                        handler: pointHandler
                    },
                    polyline: {
                        regex: /^(.*Polyline)|(.*LineString),http\:\/\/www.Gs.com$/,
                        handler: polylineHandler
                    },
                    polygon: {
                        regex: /^(.*Polygon),http\:\/\/www.Gs.com$/,
                        handler: polygonHandler
                    }
                };
                for (var k in obj) {
                    var regex = obj[k].regex;
                    if (regex.test(geom.$type)) {
                        obj[k].handler(geom, plot);
                        break;
                    }
                }
                // 2020年3月24日 自有面支持编辑
                var eles = plotElement.elements;
                var geos = plotElement.algorithm.createGeometries(plotElement.plot.copy());
                for (var i = 0, len = eles.length; i < len; ++i) {
                    var ele = eles[i];
                    var geo = geos[i];
                    geo.setSpatialReference(geom.spatialReference);
                    ele.geometry = geo;
                }
                this._plotLayer.update(plotElement);

                function pointHandler(geom, plot) {
                    plot.controlPoints = [geom];
                    plot.update([geom]);
                }

                function polylineHandler(geom, plot) {
                    var paths = geom.paths || [];
                    if (geom instanceof g2.sfs.LineString) {
                        paths = [geom];
                    }
                    if (paths.length == 1) {//单线
                        var path = paths[0];
                        plot.controlPoints = plot.controlPoints.concat(path.points);
                        plot.update([geom]);
                    }
                }

                function polygonHandler(geom, plot) {
                    var rings = geom.rings || [];
                    // 2020年3月24日 完善代码
                    if (rings.length === 0 && geom.shell) {
                        rings = [geom.shell];
                    }
                    if (rings.length == 1) {//单面且无洞
                        var ring = rings[0];
                        plot.controlPoints = plot.controlPoints.concat(ring.points);
                        plot.update([geom]);
                    }
                }
            },
        });
        /***
         * 内部方法
         */
        component.include({
            /**
             * 初始化命令、工具
             * @private
             */
            _initTools: function () {
                var g2map = this.map;
                //创建一个命令管理实例，用来管理所有命令
                var commandMgr = new g2.gdm.CommandManager();
                //创建命令通知实例，用来命令之间的相互通知，传入命令管理对象
                var commandNotify = new g2.gdm.CommandNotify({
                    manager: commandMgr
                });
                //
                this._commandMgr = commandMgr;
                this._commandNotify = commandNotify;
                //
                var nooptool = new g2.interact.NoopTool({
                    id: "NoopTool",
                    cursor: this.options.cursor
                });
                var plotEditTool = new g2.plot.PlotEditTool({
                    id: "PlotEdit",
                    layer: this._plotLayer
                });
                // //引线标注编辑工具
                var leadLabelEditTool = new g2.basic.LeadLabelEditTool3D({
                    id: 'leadLabelEditTool',
                    layer: this._tailedLayer
                });
                commandMgr.add(nooptool);
                commandMgr.add(plotEditTool);
                commandMgr.add(leadLabelEditTool);
                this._plotEditTool = plotEditTool;
                this._tailedEditTool = leadLabelEditTool;
                //编辑工具方法重写，用于监听编辑完成的事件
                var self = this;
                this._plotEditTool.endEdit = this._plotEditTool.endEdit.before(function () {
                    var elements = self.getSelectedElements();
                    if (elements.length > 0) {
                        self._fireEvent(AppEvents.PLOT_UPDATED, {
                            element: elements[0].element
                        });
                    }
                });
                this._nooptool = nooptool;
                //
                var graphicSet = new g2.carto.GraphicSelectionSet();
                this._commandHook = {
                    map: g2map,
                    commandNotify: commandNotify,
                    graphicSelectionSet: graphicSet,
                    spatialRef: {
                        srid: g2map.getSrid()
                    }
                };
                //命令构造器
                commandMgr.onCreate(this._commandHook);
            },
            /**
             * 移除标绘
             * @method
             * @param id {String} - 必填，移除的元素id
             * @returns {Element}
             */
            _removePlotElement: function (id) {
                var plotElement = this._plotLayer.find(id);
                if (plotElement) {
                    this._plotLayer.remove(plotElement);
                    return plotElement;
                } else {
                    LoggerUtil.warn('移除的元素不存在，id=' + id);
                    return null;
                }
            },
            /***
             * 获取默认的算法
             * @param type
             */
            _getAlgorithm: function (type, opts) {
                if (CommonUtil.isString(type)) {
                    type = type.replace('Algorithm', '');
                    var obj = TYPES[type] || null;
                    var algm = null;
                    var algoClazz = g2.plot[obj.algorithm];
                    if (obj && CommonUtil.isFunction(algoClazz)) {
                        if (opts) {
                            algm = new algoClazz({
                                size: opts.size, //单位是像素
                                map: opts.map
                            });
                        } else {
                            algm = new algoClazz({});
                        }
                        //保存类型信息
                        algm._type = obj.type;
                    }
                    return algm;
                }
                return null;
            },
            /**
             * 获取默认的符号
             * @param type
             * @param symbol
             * @private
             */
            _getDefaultSymbol: function (type, symbol) {
                if (!CommonUtil.isObject(symbol)) {
                    symbol = this.options.symbols[type];
                }
                return RenderUtil.object2Symbol(symbol.type, symbol.options);
            },
            /***
             * 构造标绘工具
             * @param opts {Object}
             * @param opts.type {String} 必填，标绘的类型
             * @param opts.pattern {String} 必填，点线面；
             * @param opts.algorithm {g2.plot.PlotAlgorithm} 可选，算法对象
             * @param opts.geometry {g2.sfs.Geometry} 必填，几何对象
             * @param opts.symbol {Object} 可选，符号对象
             * @param opts.callback {Function} 可选，绘制完成的回调，回调参数为当前标绘的元素
             * @param opts.context {Object} 可选，绘制完成的回调上下文
             * @private
             */
            _constructPlotTool: function (opts) {
                if (!opts) {
                    throw (new Error('参数类型错误！'));
                }
                var self = this,
                    algorithm = opts.algorithm || this._getAlgorithm(opts.pattern),
                    name = '';
                if (opts.pattern == PATTERNS.TEXT) {
                    name = 'text';
                } else if (opts.pattern == PATTERNS.POINT) {
                    name = 'point';
                } else if (opts.pattern == PATTERNS.POLYLINE) {
                    name = 'polyline';
                } else if (opts.pattern == PATTERNS.POLYGON) {
                    name = 'polygon';
                } else if (opts.pattern == PATTERNS.COMPOSITE) {
                    name = 'composite';
                } else if (opts.pattern == PATTERNS.TAILEDTEXT) {
                    name = 'tailedtext';
                } else if (opts.pattern == PATTERNS.OVERLAY) {
                    name = 'overlay';
                }
                const eleName = opts.name || name;
                const businessId = opts.businessId;
                var geometry = opts.geometry;
                var templateEle = null, elements = [];
                //composite
                if (CommonUtil.isArray(geometry)) {
                    var symbols = opts.symbol || [];
                    templateEle = new g2.sfs.Element({
                        geometry: geometry[1],
                        symbol: this._getDefaultSymbol(PATTERNS.POLYLINE, symbols[1])
                    });
                    var assistEle = new g2.sfs.Element({
                        geometry: geometry[0],
                        symbol: this._getDefaultSymbol(PATTERNS.POLYGON, symbols[0])
                    });
                    elements = [assistEle, templateEle];
                } else {
                    var symbol = this._getDefaultSymbol(opts.pattern, opts.symbol);
                    // if (name=="tailedtext"){
                    //
                    // }else{
                    if (opts.text) {
                        symbol.text = opts.text;
                    }
                    templateEle = new g2.sfs.Element({
                        geometry: geometry,
                        symbol: symbol
                    });
                    elements = [templateEle];
                    // }

                }
                var tool = new g2.plot.PlotTool({
                    id: CommonUtil.newUUID32(),
                    drawTemplate: templateEle,
                    algorithm: algorithm,
                    elements: elements,
                    name: eleName,
                    pickZ: true,
                    plotLayer: this._plotLayer
                });
                tool.onCreate(this._commandHook);
                tool._onMouseUp = tool.onMouseUp;
                tool.onMouseUp = function () {
                    try{
                        tool._onMouseUp.apply(tool, arguments);
                    }catch(e){}
                    onMouseUp.apply(self, arguments);
                };
                tool.onEndDraw = function (plotElement) {
                    onEndDraw.call(self, plotElement, opts);
                }
                tool.onPosition3d = function (mapx, mapy, mapz) {
                    if (!!this.pickZ) {
                        this.mapz = mapz;
                    }
                }
                this._currentTool = tool;
                return tool;
                function onMouseUp(button, shift, screenx, screeny, mapx, mapy, handled) {
                    //最后依次点击的控制点
                    this._lastControlPoint = new g2.sfs.Point({
                        x: mapx,
                        y: mapy,
                        spatialReference: this.map.getSrid()
                    });
                }

                function onEndDraw(plotElement, opts) {
                    this._cancelPlot();
                    plotElement.kind = name;
                    plotElement.tag.businessId = businessId;
                    //调用回调
                    if (CommonUtil.isFunction(opts.callback)) {
                        if (name === 'overlay') {
                            setTimeout(() => { // 延迟处理，等待地图事件处理完毕
                                opts.callback.call(opts.context, plotElement, opts.overlayOpt, this);
                            }, 300);
                        }  else if (name === 'tailedtext') {
                            opts.callback.call(opts.context, plotElement, opts.tailedtext_symbol, this);
                        } else {
                            opts.callback.call(opts.context, plotElement, this);
                        }
                    }
                    // 重置编辑状态
                    Promise.resolve().then(() => {
                        this._resetToolState();
                    });
                    //派发事件
                    this._fireEvent(AppEvents.PLOT_CREATED, {
                        type: opts.type,//标绘类型
                        element: plotElement//标绘元素
                    });
                }
            },
            _loadTailedlabel: function (ele) {
                let options = JSON.parse(ele.tailedLabelAttr)
                let self = this;
                let layer = this.getTailedLayer();
                let opts = {};
                const z = ele.elements[0].geometry.z || 0;
                let size = options.size;
                if (!size || size < 6) {
                    size = 6;
                }
                if (options.domClassName || options.domHtml) { // 旧的引线文本存的内容
                    const fillColor = this._hex2ColorObj(options.domStyle.background);
                    const foregroundColor = this._hex2ColorObj(options.domStyle.color);
                    const a = options.domStyle.opacity * 255;
                    const textBackgroundBorderColor = this._hex2ColorObj('#' + options.domStyle.border.split('#')[1]);
                    let angle = 450 - options.tailAngle;
                    if (angle >= 360) {
                        angle = angle - 360;
                    }
                    opts = {
                        id: options.id,
                        dimension: 3,
                        anchor: new g2.sfs.Point({ x: ele.elements[0].geometry.x, y: ele.elements[0].geometry.y, z, spatialReference: ele.elements[0].geometry.spatialReference }),
                        label: options.domHtml,
                        fontSize: parseInt(options.domStyle['font-size'].split('px')[0], 10),
                        foregroundColor: new g2.sfs.Color({ r: foregroundColor.r, b: foregroundColor.b, g: foregroundColor.g, a: a }),// 字体颜色
                        backgroundColor: new g2.sfs.Color({ r: fillColor.r, b: fillColor.b, g: fillColor.g, a: a }),// 背景颜色 "a": 153,
                        textBorderColor: new g2.sfs.Color({ r: foregroundColor.r, b: foregroundColor.b, g: foregroundColor.g, a: a }),
                        textBorderThickness: 0,
                        fontFamilyName: options.domStyle['font-family'] || '',
                        textBackgroundBorderColor: new g2.sfs.Color({ r: textBackgroundBorderColor.r, b: textBackgroundBorderColor.b, g: textBackgroundBorderColor.g, a: a }),
                        textBackgroundBorderThickness: parseInt(options.domStyle.border.split('px')[0], 10),
                        leadLength: options.tailLength,
                        angle: angle,
                        lineColor: new g2.sfs.Color(options.symbol.options.color),
                        lineWidth: options.symbol.options.width,
                        size: size,
                        padding: options.domMinGap
                    }
                } else {
                    opts = {
                        id: options.id,
                        dimension: 3,
                        anchor: new g2.sfs.Point({ x: options.anchor.x, y: options.anchor.y, z, spatialReference: options.anchor.spatialReference }),
                        label: options.label,
                        fontSize: options.fontSize,
                        fontFamilyName: options.fontFamilyName || '',
                        foregroundColor: new g2.sfs.Color({ r: options.foregroundColor.r, b: options.foregroundColor.b, g: options.foregroundColor.g, a: options.foregroundColor.a }),// 字体颜色
                        backgroundColor: new g2.sfs.Color({ r: options.backgroundColor.r, b: options.backgroundColor.b, g: options.backgroundColor.g, a: options.backgroundColor.a }),// 背景颜色 "a": 153,
                        textBorderColor: new g2.sfs.Color({ r: options.textBorderColor.r, b: options.textBorderColor.b, g: options.textBorderColor.g, a: options.textBorderColor.a }),
                        textBorderThickness: options.textBorderThickness,
                        textBackgroundBorderColor: new g2.sfs.Color({ r: options.textBackgroundBorderColor.r, b: options.textBackgroundBorderColor.b, g: options.textBackgroundBorderColor.g, a: options.textBackgroundBorderColor.a }),
                        textBackgroundBorderThickness: options.textBackgroundBorderThickness,
                        leadLength: options.leadLength,
                        angle: options.angle,
                        lineColor: new g2.sfs.Color({ r: options.lineColor.r, b: options.lineColor.b, g: options.lineColor.g, a: options.lineColor.a }),
                        lineWidth: options.lineWidth,
                        size: size,
                        // TODO egis更新后 把这里改回options.padding
                        padding: options.padding,
                    }
                }
                opts.textAlign = options.textAlign || 'center';
                const leadLabel = new g2.sfs.LeadLabel(opts);
                leadLabel.tag = {
                    businessId: ele.tag.businessId,
                }
                leadLabel.schemaId = ele.schemaId;
                layer.add(leadLabel);
            },
            _hex2ColorObj: function (colorHex) {
                const str = colorHex.substr(1);
                const opts = {
                    a: 255,
                    r: 0,
                    g: 0,
                    b: 0,
                };
                if (str.length === 3) {
                    opts.r = parseInt(str[0] + str[0], 16);
                    opts.g = parseInt(str[1] + str[1], 16);
                    opts.b = parseInt(str[2] + str[2], 16);
                } else {
                    opts.r = parseInt(str[0] + str[1], 16);
                    opts.g = parseInt(str[2] + str[3], 16);
                    opts.b = parseInt(str[4] + str[5], 16);
                }
                return new g2.sfs.Color(opts);
            },
            _loadOverlay: function (ele) {
                let options = JSON.parse(ele.overlayAttr);
                this._plotOverlayTool.add(options);
            },
            /* _loadTailedlabel: function (ele) {
                
                let options = JSON.parse(ele.tailedLabelAttr)
                let self = this;
                
                let layer = this.options.tailedLabelComponent.getLayer();//.layer;
                // let layer = this._plotLayer;
                var tailOpts = {};
                //引线指向点
                let point = {
                    type: 'Point',
                    coordinates: [ele.elements[0].geometry.x, ele.elements[0].geometry.y]
                };
                tailOpts.geometry = point;
                tailOpts.label = options.domHtml;
                tailOpts.id = ele.id;
                tailOpts.symbol = options.symbol
                tailOpts.domClassName = options.domClassName;
                tailOpts.tailLength = options.tailLength;
                tailOpts.tailAngle = options.tailAngle;
                tailOpts.showArrow = options.showArrow;
                tailOpts.arrowAngle = options.arrowAngle;
                tailOpts.arrowScale = options.arrowScale;
                tailOpts.domStyle = options.domStyle;
                let color = tailOpts.lineColor;//split("#")[1];
                let width = tailOpts.lineWidth;//split("#")[1];
                // let color_ = g2.sfs.Color.fromHex(color)
                // tailOpts.symbol = {
                //     "type": "SimpleLineSymbol",
                //     "options": {
                //         "color": {
                //             "alpha": color.a,
                //             "r": color.r,
                //             "g": color.g,
                //             "b": color.b
                //         },
                //         "style": "5",
                //         "width": width
                //     }
                // }

                let tailedLabelId = this.options.tailedLabelComponent.add(tailOpts);
                var element = RenderUtil.geoinfoToElement(point, ele.elements[0].symbol, {
                    id:ele.id,
                    layer: layer
                });
                element.labelId = ele.id;
                let tailedLabel = this.options.tailedLabelComponent._getTailedLabel(ele.id);

                tailedLabel.on('tailedLabelClick',function () {
                    let id =ele.id;
                    self.fire('openTailedLabelEdit', self.getPlotElementById(id))
                })
                // let tailedLabelAttr = tailedLabel.serialize();
                ele.tailedLabelAttr = tailedLabel.serialize();
            }, */
            _cancelPlot: function () {
                var g2map = this.map;
                try {
                    this._resetToolState();
                    this._currentTool.deactivate();
                    this._currentTool = null;
                } catch (e) {
                }
                //reset
                this._lastControlPoint = null;
            },
            /**
             * 地图点击事件
             * @param event
             * @private
             */
            _mapClickHandler: function (screenX, screenY) {
                if (this._currentTool) {
                    return;
                }
                var screenX = screenX,
                    screenY = screenY;
                var graphic_tailed = this._tailedLayer.hitTest(screenX, screenY);
                var graphic = this._plotLayer.hitTest(screenX, screenY);
                var plotElement = null;
                if (graphic_tailed && graphic_tailed.element) {
                    if (graphic_tailed.element.parent) {
                        plotElement = this._getTailedLabelByElement(graphic_tailed.element.parent); // 通过组合元素来获取leadlabel
                    } else {
                        plotElement = this._getTailedLabelByElement(graphic_tailed.element); // 通过组合元素来获取leadlabel
                    }
                    this.dragTailedText();
                } else if (graphic && graphic.element) {
                    plotElement = graphic.element.parent;
                    this.enableEdit(true);
                }
                if (this._plotClickObj) {
                    var callback = this._plotClickObj.callback;
                    if (CommonUtil.isFunction(callback)) {
                        callback.call(this._plotLayer.context, plotElement);
                    }
                }
                //派发全局事件
                this.fire(AppEvents.PLOT_CLICKED, {
                    element: plotElement
                });

            },
            /**
           * 引线标注图层 mouseup监听 引线拖拽后，更新plotlayer中对应的那个点的坐标
           * @param {*} layer 
           */
            _tailedLabelUpdatePlot: function () {
                const labels = this._tailedLayer.leadLabels;
                for (let i = 0; i < labels.length; i++) {
                    const plotEle = this.getPlotElementById(labels[i].id);
                    if (plotEle) {
                        plotEle.geometry = labels[i].anchor;
                        plotEle.elements[0].geometry = labels[i].anchor;
                        this._plotLayer.update(plotEle, false);
                        // plotEle.elements[0].symbol.fillColor = labels[i].lineColor;
                        // plotEle.elements[0].symbol.borderColor = labels[i].lineColor;
                        // plotEle.elements[0].symbol.size = labels[i].size;
                        // this._plotLayer.update(plotEle, true);
                    }
                }
            },
            /**
            * 根据引线标准的组合要素 获取对应的引线标注
            * @param {*} ele 
            */
            _getTailedLabelByElement: function (ele) {
                if (this._tailedLayer) {
                    return this._tailedLayer.hashMap.get(ele);
                }
            },
            _getTailedLabelById: function (id) {
                if (this._tailedLayer) {
                    let label = null;
                    var labels = this._tailedLayer.leadLabels;
                    for (var i = labels.length - 1; i >= 0; i--) {
                        if (labels[i].id === id) {
                            label = labels[i];
                            break;
                        }
                    }
                    return label;
                }
              
            },
            _removeTailedTextById: function (id) {
                // let layer = this.options.tailedLabelComponent._layer
                // this.options.tailedLabelComponent.remove(id);
                if (this._tailedLayer) {
                    var labels = this._tailedLayer.leadLabels;
                    for (var i = labels.length - 1; i >= 0; i--) {
                        if (labels[i].id === id) {
                            this._tailedLayer.remove(labels[i]);
                        }
                    }
                }
             
            },
            _removeOverlayById: function (id) {
                this._plotOverlayTool.remove(id);
            },
            _sortGraphics(graphics) {
                let featureTypeList = [];
                // 按点线面顺序排序，且后加载的在上
                let pointList = [], textList = [], polylineList = [], polygonList = [], freePolygonList = [], otherList = [];
                for (let i = graphics.length - 1; i >= 0; i--) {
                    let obj = graphics[i];
                    let geometryType = obj.element.kind;
                    switch (geometryType) {
                        case 'point':
                            pointList.push(obj);
                            break;
                        case 'text':
                            textList.push(obj);
                            break;
                        case 'polyline':
                            polylineList.push(obj);
                            break;
                        case 'polygon':
                            if (obj.element.name.indexOf('freePlot') > -1) {
                                freePolygonList.push(obj);
                            } else {
                                polygonList.push(obj);
                            }
                        default:
                            otherList.push(obj);
                            break;
                    }
                }
                featureTypeList = textList.concat(pointList, polylineList, polygonList, otherList, freePolygonList);
                return featureTypeList[0];
            },

            /***
             * 重置工具状态
             */
            _resetToolState: function () {
                this._tailedEditTool.deactivate();
                if (this._plotEditTool._enabled_ === false) {
                    this._plotEditTool.deactivate();
                    this._nooptool.onClick();
                } else {
                    this._plotEditTool.onClick();
                }
            },
            _fireEvent: function (event, data) {
                //组件分发
                this.fire(event, data);
                // TODO 全局分发
                // this.map.fire(event, data);
            },
            _overlayClick: function (ele) {
                // plotElement = this._getOverlay(ele.element.parent); // 通过组合元素来获取leadlabel
                if (this._plotClickObj) {
                    var callback = this._plotClickObj.callback;
                    if (CommonUtil.isFunction(callback)) {
                        callback.call(this._plotLayer.context, plotElement);
                    }
                }
                this.fire(AppEvents.PLOT_CLICKED, {
                    element: ele
                });
            },
            _updateOverlayPlot: function(obj) {
                const plotElement = this.getPlotElementById(obj.id);
                if (plotElement) {
                    plotElement.overlayAttr = this._plotOverlayTool.serialize(obj);
                    const position = obj.overlay.position;
                    if (position && position.$type.indexOf('Point') > -1) {
                        plotElement.elements[0].geometry = position;
                    }
                    this._plotLayer.update(plotElement);
                }
            },
            /*   _addTailedComponent: function (map) {
                  //创建组件
                  var tailedLabelComponent = new TailedLabelComponent({
                      map: map,
                      layerId: 'tailed-marker-layer',
                      collision:'none',
                      symbol: {
                          type: 'SimpleLineSymbol',
                          options: {
                              "color": {
                                  "alpha": 250,
                                  "r": 183,
                                  "g": 79,
                                  "b": 79
                              },
                              "style": 5,
                              "width": 1
                          }
                      },
                      //引线长度
                      tailLength: 80,
                      tailAlign: 'auto',//引线水平
                      //dom样式名
                      domClassName: 'emap-tail-label',
                      domStyle: {
                          'background': '#b74f4f',
                          'padding': '10px',
                          'font-size': '20px',
                          'border': '1px solid #a61c00',
                          'color': "#ffffff",
                          'opacity': 1
                      },
                      //引线偏移正北方向的角度
                      tailAngle: 30,
                      //是否显示箭头
                      showArrow: false,
                      //箭头形状，默认为三角形
  //                arrowShape:'line',
                      //箭头与引线夹角
                      // arrowAngle:30,
                      // //箭头长度比例
                      // arrowScale:0.15
                  });
                  this.options.tailedLabelComponent = tailedLabelComponent;
                  //叠加数据的图层
                  var pointLayer = new g2.carto.ElementLayer({
                      id: 'pointLayer',
                      name: '选点图层',
                      map: map
                  });
                  map.addLayer(pointLayer);
                  this.options.tailedLabelComponent._layer = pointLayer;
              } */
        });
    }
    return {
        extend: fn
    }
});
